export default __webpack_public_path__ + "static/media/16.63c9ee77.jpg";